define([
	"dojo/_base/declare",
	"BusinessPlanning/StructureItemPPSwitchboard"
], function(declare,StructureItemPPSwitchboard) {

return declare(StructureItemPPSwitchboard,
	{
		productPath: "Child:ProductPlan/Child:Product"
	}
);

});